// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e1e351ef","453":"a8bf61dc","455":"6bb6c351","977":"135a0cd5"}[chunkId] + ".chunk.js";
};